import { jsxs as o, jsx as r } from "react/jsx-runtime";
import { Animated as m } from "@tameeni/ui";
import { HomeSection as n } from "../home-section/home-section.js";
import { SectionSubtitle as c } from "../typography/section-subtitle.js";
import { SectionTitle as l } from "../typography/section-title.js";
import { ProductCard as s } from "./product-card.js";
function x({ title: t, subtitle: e, children: i }) {
  return /* @__PURE__ */ o(n, { className: "max-xl:pe-0", children: [
    /* @__PURE__ */ o("div", { className: "mb-8", children: [
      /* @__PURE__ */ r(l, { children: t }),
      /* @__PURE__ */ r(c, { children: e })
    ] }),
    /* @__PURE__ */ r("section", { children: i })
  ] });
}
function S({ idx: t, ...e }) {
  return /* @__PURE__ */ r(
    m.FadeIn,
    {
      className: "h-full",
      useScroll: !0,
      transition: { delay: t * 0.15 },
      children: /* @__PURE__ */ r(s, { ...e })
    }
  );
}
export {
  S as ProductItem,
  x as ProductsList
};
//# sourceMappingURL=index.js.map
